import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/service/rest.service';
import { FacultyService } from 'src/app/service/faculty.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-instrctor-details',
  templateUrl: './instrctor-details.component.html',
  styleUrls: ['./instrctor-details.component.css']
})
export class InstrctorDetailsComponent implements OnInit {
  SLIDER_IMAGE = ''
  facultyName : ''
  facult_date : ''
  facultyId
  instrctorId
  techDetails
  branch_id
  constructor(private rest : FacultyService , private restService : RestService , private route : ActivatedRoute) { }

  ngOnInit(): void {
    this.facultyId = this.route.snapshot.paramMap.get('id')
    this.instrctorId = this.route.snapshot.paramMap.get('name')
    // branch_id is saved in localStorage during normal navigation; fall back to
    // the main branch so a direct visit still loads the hero (API rejects empty).
    this.branch_id = localStorage.getItem('branch_id') || '1'
    // Opened from a specific institute: we already know the faculty id, load its
    // hero straight away. Opened academy-wide (id = 0): resolve the institute from
    // the member's faculty name once the profile data arrives (see getData).
    if (this.facultyId && this.facultyId !== '0') {
      this.loadFacultyHero(this.facultyId, this.branch_id)
    }
    this.getData()
  }

  getData(){
    this.rest.getTechDteails(this.instrctorId).subscribe((res:any) => {
      this.techDetails = res
      // Ensure the hero always shows the institute name even if facultyHome fails.
      if (!this.facultyName && res?.faculty) {
        this.facultyName = res.faculty
      }
      // Academy-wide entry has no faculty id in the route; find it by name so the
      // hero shows the right institute banner and establishment date.
      if ((!this.facultyId || this.facultyId === '0') && res?.faculty) {
        this.resolveFacultyByName(res.faculty)
      }
    })
  }

  // Loads the institute hero (banner image, name, establishment date).
  loadFacultyHero(facultyId, branchId){
    this.rest.facultyHome(facultyId, branchId).subscribe((res:any) => {
      this.SLIDER_IMAGE = res.SLIDER_IMAGE
      this.facultyName = res.FACULTY_NAME
      this.facult_date = res.DATE_ESTABLISH
      // Tell the nav which institute this member actually belongs to, so the
      // header shows the right name/logo/departments instead of the host default.
      this.restService.setFacultyContext(facultyId, res.FACULTY_NAME, branchId)
    })
  }

  // Matches the member's institute name against the branches/faculties list to
  // recover its id, then loads the proper hero for it.
  resolveFacultyByName(name){
    this.restService.GetBranchesFaculties().subscribe((res:any) => {
      const target = this.normalizeArabic(name)
      const branches = res?.branches || []
      for (const branch of branches) {
        const faculties = branch?.faculty || []
        for (const f of faculties) {
          if (this.normalizeArabic(f.FACULTY_NAME) === target) {
            this.facultyId = f.ID
            this.branch_id = branch.branch_id
            this.loadFacultyHero(f.ID, branch.branch_id)
            return
          }
        }
      }
    })
  }

  // Normalises Arabic spelling variants (أ/إ/آ → ا, ى → ي, ة → ه, tatweel,
  // extra spaces) so institute names match across the two API endpoints.
  normalizeArabic(text): string {
    return String(text || '')
      .replace(/ـ/g, '')
      .replace(/[أإآ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/\s+/g, ' ')
      .trim()
  }

  // Splits the long free-text fields (which use ▪ bullets and line breaks)
  // into a clean array of trimmed items so we can render a proper list.
  splitToList(text): string[] {
    if (!text) { return [] }
    return String(text)
      .split(/[▪•·\r\n]+/)
      .map(line => line.replace(/^[\s"\-–—•]+|[\s"]+$/g, '').trim())
      .filter(line => line.length > 0)
  }

  // Returns true when a free-text field actually has content.
  hasText(text): boolean {
    return !!text && String(text).trim().length > 0
  }

  // True when the member has at least one populated detail section.
  hasAnyContent(): boolean {
    const d = this.techDetails
    if (!d) { return false }
    return this.hasText(d.Scientific_intellectual_production)
      || this.hasText(d.Scholarships_curricula)
      || this.hasText(d.References_encyclopedias)
      || !!(d.Academic_qualifications_certificates && d.Academic_qualifications_certificates.length)
      || !!(d.Jobs_professions && d.Jobs_professions.length)
      || !!(d.honors_awards && d.honors_awards.length)
  }

  // Returns a copy of the list sorted by acquire_date, most recent first.
  sortByDateDesc(list): any[] {
    if (!list || !list.length) { return [] }
    return list.slice().sort((a, b) => {
      const ya = parseInt(this.getYear(a?.acquire_date), 10) || 0
      const yb = parseInt(this.getYear(b?.acquire_date), 10) || 0
      return yb - ya
    })
  }

  // Extracts just the year from values like "2001-01-01" or "01/10/1977".
  getYear(date): string {
    if (!date) { return '' }
    const match = String(date).match(/\d{4}/)
    return match ? match[0] : String(date)
  }
}
